import {
    FormConfigBuilder,
    GLOBAL_FIELD_PROPS,
} from 'components/form-builder/FormConfigBuilder';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import { MilitaryUnit } from 'models/nostradamus/administration/MilitaryUnit';
import api from 'services/api';

const flattenUnits = (units) => {
    const result = [];
    const queue = [...units];
    while (queue.length > 0) {
        const unit = queue.shift();
        result.push(unit);
        if (unit.children?.length) queue.push(...unit.children);
    }
    return result;
};

const checkNameUnique = async (name) => {
    if (!name || name.trim().length === 0) return true;
    try {
        const { data } = await api.get('api/analytics/military-units', {
            params: { hideArchived: false },
        });
        const units = data?.data || data?.body?.data || [];
        const allUnits = flattenUnits(Array.isArray(units) ? units : []);
        return !allUnits.some(u => u.name?.toLowerCase() === name.trim().toLowerCase());
    } catch {
        return true;
    }
};

const militaryUnitConfig = (methods = null, watch = null) => {
    const selectedType = methods?.watch?.('type');

    return new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'name',
                title: 'Unit Name',
                validations: [
                    ['required', true],
                    ['test', ['uniqueName', 'Unit with this name already exists', checkNameUnique]],
                ],
                asyncValidate: checkNameUnique,
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomAutoComplete,
                attribute: 'type',
                title: 'Unit Type',
                col: {
                    sm: 12,
                },
                props: {
                    ...GLOBAL_FIELD_PROPS.props,
                },
                optionConfig: {
                    key: 'type',
                    value: 'type',
                    label: 'label',
                },
                validations: [['required', true]],
                async: {
                    url: '/api/analytics/military-units/types',
                    immediate: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomAutoComplete,
                attribute: 'parentUnitId',
                title: 'Parent Unit',
                col: {
                    sm: 12,
                },
                props: {
                    ...GLOBAL_FIELD_PROPS.props,
                    disabled: !selectedType,
                },
                optionConfig: {
                    key: 'id',
                    value: 'id',
                    label: 'name',
                },
                validations: [['required', true]],
                async: {
                    url: '/api/analytics/military-units/names',
                    params: {
                        hideArchived: true,
                        parentRequired: true,
                        unitType: (formValues) => formValues?.type || '',
                    },
                    immediate: !!selectedType,
                },
            },
        ],
        MilitaryUnit,
    );
};

const MilitaryUnitConfig = [{ label: 'Unit', config: militaryUnitConfig }];

export default MilitaryUnitConfig;
